"use client";

import * as React from "react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroSection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="244176" id="buyer-portal-overview" className="relative w-full min-h-[60vh] md:min-h-[70vh] flex items-center justify-center py-20 overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/buyer_portal_interface.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/buyer_portal_interface.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/buyer_portal_interface.png-wvc-sizes" alt="Buyer Portal Platform Interface" className="w-full h-full object-cover" loading="lazy" decoding="async" />
        {}
        <div className="absolute inset-0 bg-primary/85 mix-blend-multiply"></div>
        <div className="absolute inset-0 bg-primary/60 backdrop-blur-sm"></div>
      </div>

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-4 md:px-6 text-center transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 font-default tracking-tight max-w-5xl mx-auto leading-tight">
          Streamline Your Procurement with Our Buyer Portal
        </h1>
        
        <p className="text-lg md:text-xl lg:text-2xl text-white/90 mb-10 max-w-3xl mx-auto font-default font-medium">
          Access real-time inventory, manage orders, and optimize your supply chain through one professional platform.
        </p>
        
        <Button size="lg" className="bg-accent hover:bg-accent-hover text-white font-bold text-base md:text-lg px-8 py-6 h-auto rounded-sm shadow-strong transition-transform hover:scale-105">
          Explore the Buyer Portal
        </Button>
      </div>
    </section>;
}